/**
 * Router for Documents
 */

import { DocumentSignFlow } from './pages/document-sign-flow/DocumentSignFlow'

import type { RouteObject } from 'react-router-dom'

const signableDocumentsRoutes: RouteObject[] = [
  {
    path: 'sign/:id',
    children: [
      {
        index: true,
        path: '*',
        element: <DocumentSignFlow />,
      },
    ],
  },
]

export { signableDocumentsRoutes }
